import { useTranslation } from 'next-i18next';

import { Box, Flex, Text, useSlotRecipe } from '@chakra-ui/react';

import { wordPluralisation } from '@nocowanie/common-ui/helpers';

import { RatingRate } from '@app/components/molecules/rating-rate';
import { getRatingDescValue } from '@app/helpers/get-rating-desc-value';

import { RatingProps } from './rating.props';

export const Rating = ({
    ratingAverage,
    ratingCount,
    ratingDescription,
    labelProps = {},
    ratingProps = {},
    t,
    variant,
    ...props
}: RatingProps) => {
    const breakOn = 'md';
    const { t: translations } = useTranslation('accommodation');
    const translate = t || translations;

    const recipe = useSlotRecipe({ key: 'rating' });
    const styles = recipe({
        variant: variant,
    });

    const translationOpinionsValue = translate('opinions', {
        returnObjects: true,
    }) as Record<string, string>;

    return (
        <Flex data-testid={'rating'} css={styles.container} {...props}>
            <RatingRate
                ratingAverage={ratingAverage}
                css={styles.ratingNumerical}
                {...ratingProps}
            />
            <Flex
                hideBelow={variant === 'hideLabelsOnMobile' ? breakOn : undefined}
                css={styles.descriptionContainer}
            >
                <Box
                    css={styles.ratingDescription}
                    truncate
                    data-testid="rating-text"
                    {...labelProps}
                >
                    {getRatingDescValue(ratingDescription)}
                </Box>
                <Text as={'span'} css={styles.ratingCount} data-testid="rating-count">
                    {ratingCount}{' '}
                    {wordPluralisation(
                        ratingCount,
                        translationOpinionsValue.singular,
                        translationOpinionsValue.plural,
                        translationOpinionsValue.genitivePlural,
                    )}
                </Text>
            </Flex>
        </Flex>
    );
};
